<template>
	<div class="locations-row clear">
		<div>
			<div>
				<span>{{ location.name }}</span>
			</div>
			<div class="m-t-xs">
				<span>{{ coordinates }}</span>
			</div>
		</div>
		<div>
			{{ location.pv_category || "&nbsp;" }}
		</div>
		<div>
			{{ location.pv_data.peak_power ? location.pv_data.peak_power : "&nbsp;" }}
		</div>
		<div>
			{{ location.pv_data.tracking ? location.pv_data.tracking : "&nbsp;" }}
		</div>

		<div>
			{{ location.pv_data.azimuth ? location.pv_data.azimuth + "º" : "&nbsp;" }}
		</div>
		<div>
			{{ location.pv_data.tilt || "&nbsp;" }}
		</div>
		<div>
			{{ location.pv_data.losses ? location.pv_data.losses + " %" : "&nbsp;" }}
		</div>

		<div>
			<font-awesome-icon
				class="right"
				style="cursor:pointer"
				icon="trash"
				@click="remove_location(location_key)"
			/>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
export default {
	name: "Location",
	props: ["location", "location_key"],
	data: function() {
		return {
			show_forecasts: false
		};
	},
	computed: {
		coordinates: function() {
			return (
				parseFloat(
					this.location.position[0] || this.location.position.lat
				).toFixed(3) +
				" , " +
				parseFloat(
					this.location.position[1] || this.location.position.lng
				).toFixed(3)
			);
		},
		tracking: function() {
			const tracking = {
				fixed: "Fixed",
				"1-axis": "1 axis",
				"2-axis": "2 axis"
			};
			return tracking[this.location.pv_data.tracking];
		},
		forecast: function() {
			return this.location.forecasts;
		}
	},
	methods: {
		remove_location: function(key) {
			this.$store.commit("remove_location", key);
		},
		toogle_forecasts: function() {
			this.show_forecasts = !this.show_forecasts;
		}
	}
};
</script>

<style>
.location-view-graphic {
	color: #776efc;
}
</style>
